export class ManagerCustomerUpdateDto {
  customerId: number;
  functionId: number;
}
